import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=c3c93584"
import script from "./sort.vue?vue&type=script&lang=js"
export * from "./sort.vue?vue&type=script&lang=js"
import style0 from "./sort.vue?vue&type=style&index=0&id=c3c93584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports